export const clinicNoteAction = {
  onChangeClinicNotes: (state, action) => {
    const { note, notesTouched, isOriginal = false } = action.payload;

    state.clinicNotes = note;
    if (isOriginal) {
      state.originalClinicNotes = note;
    }
    state.clinicNotesTouched = notesTouched;
  },

  setClinicNotesTouched: (state, action) => {
    state.clinicNotesTouched = action.payload;
  },

  onSpeechRecognizing: (state, action) => {
    state.isSpeechRecognizing = action.payload;
  },

  onReportFINChange: (state, action) => {
    const { fin, notesTouched, isOriginal = false } = action.payload;

    state.reportFIN = fin;
    if (isOriginal) {
      state.originalReportFIN = fin;
    }
    state.clinicNotesTouched = notesTouched;
  },

  onClinicEsigChange: (state, action) => {
    const { clinicName, eSig, notesTouched } = action.payload;

    if (clinicName === "Denver Heart") {
      state.esignModalOpen = true;
    } else {
      state.clinicNotesEsig = eSig;
      state.clinicNotesTouched = notesTouched;
    }
  },

  onClinicMrnChange: (state, action) => {
    const { mrn, mrnTouched } = action.payload;

    state.clinicMrn = mrn;
    state.clinicMrnTouched = mrnTouched;
  },

  resetClinicNotes: (state) => {
    state.clinicNotes = "";
    state.originalClinicNotes = "";
    state.clinicNotesTouched = false;
    state.reportFIN = "";
    state.originalReportFIN = "";
    state.clinicNotesEsig = "";
    state.clinicMrn = "";
    state.clinicMrnTouched = false;
    state.esignModalOpen = false;
  },
};
